import React from "react";
import Logo from "../../../layouts/Logo";
import useGetProfile from "../../user/hooks/useGetProfile";
import {
  UserCircleIcon,
  Bars3Icon,
} from "@heroicons/react/24/outline";
import { EXTRA_ROUTE } from "../../../routes";

interface AdminHeaderProps {
  onToggleSidebar?: () => void;
}

const AdminHeader: React.FC<AdminHeaderProps> = ({ onToggleSidebar }) => {
  const { user, loading } = useGetProfile();

  return (
    <header className="sticky top-0 z-40 bg-white shadow-sm border-b border-gray-200">
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Mobile menu button and Logo */}
          <div className="flex items-center">
            {/* Mobile menu button */}
            <button
              onClick={onToggleSidebar}
              className="lg:hidden p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 mr-2"
            >
              <Bars3Icon className="h-6 w-6" />
            </button>
            <a href="/" className="-m-1.5 p-1.5">
              <div className="scale-75 origin-left">
                <Logo />
              </div>
            </a>
            <div className="ml-2">
              <h1 className="text-lg font-semibold text-gray-900 hidden sm:block">
                Pannello Amministratore
              </h1>
              <h1 className="text-base font-semibold text-gray-900 sm:hidden">
                Admin
              </h1>
            </div>
          </div>

          {/* Right section - User menu */}
          <div className="flex items-center space-x-2 sm:space-x-4">
            {/* User Menu */}
            <div className="relative">
              <a href={EXTRA_ROUTE} className="flex items-center space-x-2 p-2 rounded-md text-gray-700 hover:bg-gray-100">
                {!loading && user?.profileImage ? (
                  <img
                    className="h-6 w-6 sm:h-8 sm:w-8 rounded-full bg-gray-50"
                    src={user.profileImage}
                    alt=""
                  />
                ) : (
                  <UserCircleIcon className="h-6 w-6 sm:h-8 sm:w-8" />
                )}
                <span className="text-sm font-medium hidden sm:block">
                  {!loading && user?.firstName ? user.firstName : "Admin"}
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default AdminHeader;
